module.exports = __webpack_public_path__ + "img/st-price.c3505920.jpg";